import type { ReactNode } from "react"
import cn from "@/v2-ui/utils/utils.cn"
import LineLoader from "@/v2-ui/lineLoader"
import { usePrimitiveText } from "@/v2-ui/text/offline"

export type PlaceholderProps = {
  loading?: boolean
  containerClassName?: string
  className?: string
  children?: ReactNode
}

function Placeholder(props: PlaceholderProps) {
  const { getText } = usePrimitiveText()
  const {
    loading = false,
    containerClassName,
    className,
    children,
    ...lineLoaderProps
  } = props
  const noDataLabel = getText("UI_Primitive_Placeholder_Root").Name

  return (
    <div
      role="alert"
      aria-label={noDataLabel}
      className={cn(
        "placeholder",
        containerClassName,
        loading ? "p-4 pb-0" : "",
      )}
    >
      <LineLoader
        isLoading={loading}
        className={cn("text-muted", className)}
        {...lineLoaderProps}
      >
        {children || noDataLabel}
      </LineLoader>
    </div>
  )
}

export default Placeholder
